import ViewBase from "../../../framework/core/mvvm/view_base";
import { ListView, ListViewDir } from "../../../framework/tools/scrollview/listview";
import ClubHallItem from "../component/club_hall_item";
import { club_utils } from "../club_utils";
import ClubHallInfo from "../component/club_hall_info";
import { joinUtil } from "../../public/join_util";
import AppData from "../../public/const/app_data";
import ClubHallServer from "../../hall/server/club/club_hall_server";
import { Hallx } from "../../hall/server/club/proto_club_hall_notify";
import Utility from "../../../utility/utility";
import ClubHallPlayer from "../component/club_hall_player";
import ClubHallTableInfo from "../component/club_hall_table_info";
import SpriteFrameHolder from "../../public/ui/spriteFrameHolder";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ClubHallView extends ViewBase {

    @property(cc.ScrollView)
    scrollView : cc.ScrollView = null;

    @property(cc.Node)
    content : cc.Node = null;

    @property(cc.Node)
    view : cc.Node = null;

    @property(cc.Node)
    itemPrefab : cc.Node = null;

    @property(cc.Node)
    transferRed : cc.Node = null;

    @property(cc.Node)
    playerPrefab : cc.Node = null;

    @property(cc.Node)
    infoPrefab : cc.Node = null;

    @property(cc.Node)
    reconnectNode : cc.Node = null;

    @property(ClubHallInfo)
    hallInfo : ClubHallInfo = null;

    @property(cc.Sprite)
    logoSprite : cc.Sprite = null;

    private clubChip : number = 0;
    private safeBoxChip : number = 0;

    private listView : ListView = null;

    private cacheRoomList : any[] = [];

    private currentLayer : any = null;

    private playerNodePool : cc.NodePool;

    private infoNodePool : cc.NodePool;

    //游戏服务器 数据缓存
    private roomMap : Map<number,Hallx.IRoomInfo> = new Map();

    onLoad(){

        this.playerNodePool = new cc.NodePool();

        this.infoNodePool = new cc.NodePool();
    }

    onShow(){

        super.onShow()
      
        if (this.reconnectNode) {
            
            this.reconnectNode.active = AppData.testMode;
        }
                

        this.registerEvent();
    }

    private reset(){

        this.roomMap.clear();

        if (this.listView) {
         
            this.listView.destroyListView();
        }

        this.currentLayer = null;

        this.listView = null;

        this.clearNodePool();
    }


    clearNodePool(){

        this.playerNodePool.clear();
        this.infoNodePool.clear();
    }

    updateLogo(style : number){

        let frame = this.getComponent(SpriteFrameHolder).getSpriteFrameByKey(style.toString());
        if (frame == null) {
            frame = this.getComponent(SpriteFrameHolder).getSpriteFrameByKey("1");
        }   
        if(frame){
            this.logoSprite.spriteFrame = frame;
        }     
    }

    private registerEvent(){

        this.roomMap.clear();
        let self = this;
        ClubHallServer.instance.onLogin = (data : Hallx.AuthRsp)=>{

            if (!self.node || !self.node.active) {
                return;
            }           
            console.log(" onClubLogin ");
        };
        ClubHallServer.instance.onRoomInfo = (data :  Hallx.RoomInfoNotify)=>{
            if (!self.node ||!self.node.active) {
                return;
            }
            
            this.updateRoom(data.roomInfo);
        };
        ClubHallServer.instance.onBatchRoomInfos = (data : Hallx.BatchRoomInfosNotify)=>{

            //全量更新
            if (!self.node ||!self.node.active) {
                return;
            }
            this.roomMap.clear();
            if (data.roomInfos && data.roomInfos.length > 0) {
                
                //更新所有房间的信息 所有层
                data.roomInfos.forEach(roomInfo=>{
                    this.updateRoom(roomInfo);
                });
            }
            
        };
        ClubHallServer.instance.onOneRoundGameResult = (data)=>{

            if (!self.node ||!self.node.active) {
                return;
            }
        };
    }


    private updateRoom(roomInfo :  Hallx.IRoomInfo){

        let roomKey = this.getRoomKey(roomInfo.seq,roomInfo.gameFieldId);
        
        let getRoom =  this.roomMap.get(roomKey);
                 
        let setInfo = new Hallx.RoomInfo();
        setInfo.id = roomInfo.id;
        setInfo.seq = roomInfo.seq ? roomInfo.seq : getRoom ? getRoom.seq : 0;
        setInfo.gameFieldId = roomInfo.gameFieldId;
        //setInfo.gameId = roomInfo.gameId ? roomInfo.gameId : getRoom ? getRoom.gameId : "0";
        //setInfo.clubId = roomInfo.clubId ? roomInfo.clubId : getRoom ? getRoom.clubId : 0;            
        //setInfo.roundNo = roomInfo.roundNo ? roomInfo.roundNo : getRoom ? getRoom.roundNo : 0; 
        //setInfo.gameFieldTag = roomInfo.gameFieldTag ? roomInfo.gameFieldTag : getRoom ? getRoom.gameFieldTag : 0; 

        if (roomInfo.headPlayers.length) {
            setInfo.headPlayers = roomInfo.headPlayers;

        }else if(getRoom) {

            setInfo.headPlayers = getRoom.headPlayers.length? getRoom.headPlayers : []; 
            
        }

        this.roomMap.set(roomKey,setInfo);

        for (let index = 0; index < this.cacheRoomList.length; index++) {
            const data = this.cacheRoomList[index];  
            if (!data) continue;
                            
            if( roomKey ==  this.getRoomKey(data.seq,data.goldId)){
                this.listView.refresh_item(index,data);
                break;
            }
        }
        
    }
    

    private getRoomKey(seq : number, goldId : number){


        for (let index = 0; index < this.currentLayer.gridList.length; index++) {
            const gridInfo = this.currentLayer.gridList[index];
            if (gridInfo.goldId == goldId && gridInfo.gameId == "CLUB_SLOT") {
                return goldId;//slot 单独处理
            }
            
        }

        return goldId * 100 + seq;
                
    }



    updateCurrency(clubChip : number,safeBoxChip : number){

        this.clubChip = clubChip;
        this.safeBoxChip = safeBoxChip;

        this.hallInfo.updateChip(this.clubChip);
        this.hallInfo.updateSafebox(this.safeBoxChip);

    }

    /**
     * 更新大厅的层级
     */
    updateHallLayer(layerInfo : any){

        this.hallInfo.refresh(club_utils.clubInfo);

        if(Utility.isEqualWithObjValue(layerInfo,this.currentLayer)){
            return;
        }

        if (this.currentLayer && this.currentLayer.clubId != layerInfo.clubId) {
            
            //如果俱乐部都不一样就把缓存清掉
            this.reset();
        }
            
        let serverRoomList  = [];

        let gridList  = [];
        gridList = layerInfo && layerInfo.status ? layerInfo.gridList : [];
        
        let pushData = null;
        for (let index = 0; index < 16; index++) {

            //默认是空白桌子
            pushData = null;
            for (let idx = 0; idx < gridList.length; idx++) {
                const gridInfo = gridList[idx];               
                if(index == (gridInfo.seq - 1) ){
                    pushData = gridInfo;
                    break;
                } 
                
            }
            
            serverRoomList.push(pushData);
        }

        this.currentLayer = layerInfo;

        if (!this.listView) {
            
            //全量更新
            let list : ListView = new ListView({
                scrollview: this.scrollView,
                view: this.view,
                content: this.content,
                item_prefab:  this.itemPrefab,
                cb_host: this,
                item_update_func: this.onItemUpdate,
                //item_click_func : this.onItemClick,
                recycle_cb : this.onRecycle,
                row: 2,
                gap_y: 30,
                direction: ListViewDir.Horizontal,
            });

            this.listView = list;
            
            this.listView.set_data(serverRoomList);  

        }else{

            
            //刷新item        
            for (let index = 0; index < serverRoomList.length; index++) {
                const server_room = serverRoomList[index];
                let cache_room = this.cacheRoomList[index];
                
                if (server_room && !cache_room 
                || !server_room && cache_room) {

                    this.listView.refresh_item(index,server_room)
                }                    
                else if ( server_room && cache_room ) {

                    if(server_room.createTime != cache_room.createTime) {
                        this.listView.refresh_item(index,server_room);
                    }

                    else if(server_room.modifyTime && cache_room.modifyTime){ 

                        if(server_room.modifyTime != cache_room.modifyTime){
                            
                            this.listView.refresh_item(index,server_room);
                        }
                    }
                    else if(server_room.modifyTime && !cache_room.modifyTime 
                        || !server_room.modifyTime && cache_room.modifyTime){

                            this.listView.refresh_item(index,server_room);
                    }
                }
         
            }          
                        
        }

        this.cacheRoomList = serverRoomList;
    
    }


    private onItemUpdate(item: cc.Node, roomData: any, index: number,item_intact ?:any){

        console.log("  itemUpdate...  index " , index );

        let com = item.getComponent(ClubHallItem);

        com.itemIndex = index;                    

        //roomData为空表示为空桌子
        if (!roomData || !roomData.gameId) {
            
        }
        else{              

            let tableCom : ClubHallTableInfo;
            //更新角色信息                
            let roomKey = this.getRoomKey(roomData.seq,roomData.goldId);        
            let roomInfo = this.roomMap.get(roomKey);  
            
            let infoNode = this.getInfoNode(item);
            tableCom = infoNode.getComponent(ClubHallTableInfo); 
        
            if(roomInfo && roomInfo.headPlayers.length){    
                
                let headPlayers = roomInfo.headPlayers;
                
                headPlayers.forEach( (head,idx)=>{
                    //如果是0表示没有玩家了.需要清空桌子
                    if(head.id != 0){
                        //百人场 没有座位
                        let playerItem = this.getPlayerNode(item);
                        let playerCom = playerItem.getComponent(ClubHallPlayer);
                        if (playerCom) {

                            let isMultiple = joinUtil.isMultiple(roomData.gameId);
                            let isJK =  roomData.gameId == "CLUB_JK";
                            //playerCom.refresh(roomData.gameId,isMultiple || isJK ? idx : head.seatSeq -1,head);
                            playerCom.refresh(roomData.gameId,idx,head);

                        }
                    }           
                })    
                let num = roomInfo.headPlayers[0].id == 0?  0 : roomInfo.headPlayers.length;
                
                tableCom.refresh(num,roomData.gameId,JSON.parse(roomData.playRule).pub_AllowNum);                 

            }else{
                tableCom.refresh(0,roomData.gameId);
            }
        }    

        let tableNode = item.children[0];        
        this.refreshTableBg(tableNode,roomData ? roomData.gameId : "EMPTY");
    }

    private refreshTableBg(tableNode : cc.Node ,gameName? : string){

        let bgSprite = tableNode.getComponent(cc.Sprite);
        let frameHolder = tableNode.getComponent(SpriteFrameHolder);
        bgSprite.spriteFrame = frameHolder.getSpriteFrameByKey(gameName? gameName : "EMPTY");
    } 

    private onRecycle(item: cc.Node){

        console.log("  onRecycle item .. ");

        if (!this.node || !this.node.active) {
            return;
        }
        let table_node = item.getChildByName("table_node");

        let playerNode = table_node.getChildByName("playerNode");
        if (playerNode) {
           //回收
            while(playerNode.children.length){
                let child = playerNode.children[0];
                if (child && child.isValid) {                 
                    this.playerNodePool.put(child);                
                }                
            }

            if (playerNode.children.length) {
             
                console.warn(" playerNode.children length " , playerNode.children.length);
            }            
        }        

        
        let infoNode = table_node.getChildByName("infoNode");
        
        if (infoNode) {
            let infoItem = infoNode.getChildByName("infoItem");
            if (infoItem && infoItem.isValid) {             
                this.infoNodePool.put(infoItem);
            }            

            if (infoNode.children.length) {
             
                console.warn(" infoNode.children length " , infoNode.children.length);
            }            
        }        
    }


    private getPlayerNode(tableItem : cc.Node){

        let playerItem = this.playerNodePool.get();

        while(this.playerNodePool.size()> 0 && (!playerItem || !playerItem.isValid)){
            playerItem = this.playerNodePool.get();            
        }

        if (!playerItem) {            
            playerItem = cc.instantiate(this.playerPrefab);
        }

        let table_node = tableItem.getChildByName("table_node");     
        let playerNode = table_node.getChildByName("playerNode");   
        playerItem.parent = playerNode;
        playerItem.position = cc.Vec3.ZERO;

        playerItem.active = true;
        return playerItem;
    }

    private getInfoNode(tableItem : cc.Node){

        let infoItem = this.infoNodePool.get();

        while(this.infoNodePool.size()> 0 && (!infoItem || !infoItem.isValid)){
            infoItem = this.infoNodePool.get();            
        }

        if (!infoItem) {            
            infoItem = cc.instantiate(this.infoPrefab);
        }

        let table_node = tableItem.getChildByName("table_node");  
        let infoNode = table_node.getChildByName("infoNode");      
        infoItem.parent = infoNode;
        infoItem.position = new cc.Vec3(0,11.56);

        infoItem.active = true;
        return infoItem;
    }    

    public joinRoom(item : ClubHallItem){

        let roomInfo = this.cacheRoomList[item.itemIndex];
        if (!roomInfo) {
            //表示是空桌子
            return;
        }

        AppData.gameName = roomInfo.gameId;

        if (joinUtil.isMultiple(roomInfo.gameId)) {
            
            joinUtil.joinMultiple(JSON.parse(roomInfo.playRule),this.clubChip,0,null,"",roomInfo.seq,roomInfo.goldId);

        }else{

            let roomIx = AppData.gameName == "CLUB_SLOT" ? 0 : roomInfo.seq;
            
            joinUtil.joinMatch(roomInfo,this.clubChip,roomIx);
        }
    }

}
